import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Bell, Check } from "@phosphor-icons/react";

const SEV_DOT = { error: "bg-red-500", warning: "bg-amber-500", success: "bg-emerald-500", info: "bg-blue-500" };

export default function NotificationBell() {
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data);
    } catch {}
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const unread = items.filter(i => !i.read).length;

  const markAll = async () => {
    await api.post("/notifications/mark-all-read");
    load();
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" data-testid="notifications-btn" className="relative">
          <Bell size={20}/>
          {unread > 0 && (
            <span className="absolute top-1.5 right-1.5 w-4 h-4 bg-primary text-primary-foreground text-[9px] font-bold rounded-full flex items-center justify-center">{unread > 9 ? "9+" : unread}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 p-0" data-testid="notifications-panel">
        <div className="flex items-center justify-between p-3 border-b border-border">
          <div className="font-display font-bold">Notifications</div>
          {unread > 0 && <button onClick={markAll} className="text-xs text-primary font-semibold hover:underline" data-testid="notif-mark-all">Mark all read</button>}
        </div>
        <ScrollArea className="h-80">
          {items.length === 0 ? (
            <div className="text-sm text-muted-foreground text-center py-12">No notifications</div>
          ) : (
            <div className="divide-y divide-border">
              {items.map(n => (
                <div key={n.id} className={`p-3 flex gap-3 ${!n.read ? "bg-primary/5" : ""}`} data-testid={`notif-${n.id}`}>
                  <div className={`w-2 h-2 mt-2 rounded-full ${SEV_DOT[n.severity] || SEV_DOT.info}`}/>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-semibold text-foreground">{n.title}</div>
                    <div className="text-xs text-muted-foreground">{n.detail}</div>
                    <div className="text-[10px] text-muted-foreground/70 mt-0.5">{new Date(n.created_at).toLocaleString()}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </ScrollArea>
      </PopoverContent>
    </Popover>
  );
}
